import { map } from "lodash";
import { getAsset, userLogs } from "./Common";
import { createTask } from "../Layouts/Task/Services";
import { getClassLearners } from "../Layouts/Assign/Services";
import { createAssignment } from "../Layouts/Assign/Services";
import { convertMinToSecond } from "./TimeAndDate";

export const autoAssignTask = (assets, title, class_id) => {};

export const autoCreateTask = async (
  assets,
  title,
  description,
  userInfo,
  productId,
  type
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let taskName = title;
      let assetInfo = await getAssetData(map(assets, "id"));
      let dataObj = {
        created_by: userInfo.uid,
        title: title,
        tags: { tags: ["autoassign"] },
        data1: {
          exersices: map(assets, "id"),
          evaluationExe: [],
          exeInfo: assetInfo,
        },
        estimated_time: assets.reduce((total, val) => {
          return total + Number(convertMinToSecond(val.duration));
        }, 0),
        description: `Task for ${description} created by auto assign`,
        site_uuid: userInfo.site_uuid,
        tasktype: type,
        product_uid: productId,
      };

      let logObj = {
        actor: userInfo.uid,
        verb: "task",
        outcome: {
          duration: 5000,
        },
        site_uuid: userInfo.site_uuid,
      };

      let response = await createTask(dataObj);
      logObj["outcome"]["action"] = "create";
      logObj["target"] = response.data.uid;
      logObj["outcome"]["value"] = response.data.data1;

      if (response.status == 200) {
        let logResponse = await userLogs(logObj);
      }
      resolve(response.data);
    } catch (error) {
      resolve(error);
    }
  });
};

let getAssetData = async (assetIds) => {
  return new Promise(async (resolve, reject) => {
    try {
      let assetData = await getAsset({
        $in: assetIds,
      });

      let assetInfo = assetData.data.map((val, ind) => {
        let jsondata = JSON.parse(val.content);
        return {
          asset_id: val.asset_uid,
          skills: jsondata.content.info.skills,
          asset_type: jsondata.content.info.asset_type_alias,
          difficulty: jsondata.content.info.difficulty_level,
          cefr_level: "",
        };
      });

      resolve(assetInfo);
    } catch (err) {
      resolve(err);
    }
  });
};

export const autoCreateAssignment = async (
  classid,
  title,
  description,
  userInfo,
  task,
  commences,
  expiries
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let learnersData = await getClassLearners([classid], userInfo.site_uuid);
      let assignmentData = {
        title: title,
        created_by: userInfo.uid,
        tasks: { tasks: [task.uid] },
        learners: { learners: map(learnersData.data, "uid") },
        commences: commences,
        expiries: expiries,
        estimated_time: task.estimated_time,
        description: `Assignment for ${description} created by auto assign`,
        defaults: {
          defaults: {
            noofattempts: "3",
            showattemptpopup: true,
            showpreviousbutton: false,
            shufflefunctionality: false,
            showgotofunctionality: false,
            showresetfunctionality: true,
            showanswerfunctionality: true,
          },
        },
        site_uuid: userInfo.site_uuid,
        is_exam: false,
      };

      // Log object
      let logObj = {
        actor: userInfo.uid,
        verb: "assignment",
        outcome: {
          duration: 5000,
        },
        site_uuid: userInfo.site_uuid,
      };

      let response = await createAssignment(assignmentData);
      logObj["outcome"]["action"] = "create";
      logObj["target"] = response.data.uid;
      logObj["outcome"]["value"] = {
        learners: response.data.learners.learners,
        tasks: response.data.tasks.tasks,
      };
      if (response.status == 200) {
        let logResponse = await userLogs(logObj);
      }
      resolve(response);
    } catch (error) {
      resolve(error);
    }
  });
};

export const prepareAssignObj = (
  classid,
  title,
  userInfo,
  task,
  commences,
  expiries
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let learnersData = await getClassLearners([classid], userInfo.site_uuid);
      let assignmentData = {
        title: title,
        created_by: userInfo.uid,
        tasks: { tasks: [task.uid] },
        learners: { learners: map(learnersData.data, "uid") },
        commences: commences,
        expiries: expiries,
        estimated_time: task.estimated_time,
        description: `Assignment ${title} created by auto assign`,
        defaults: {
          defaults: {
            noofattempts: "3",
            showattemptpopup: true,
            showpreviousbutton: false,
            shufflefunctionality: false,
            showgotofunctionality: false,
            showresetfunctionality: true,
            showanswerfunctionality: true,
          },
        },
        site_uuid: userInfo.site_uuid,
        is_exam: false,
      };

      resolve(assignmentData);
    } catch (error) {
      resolve(error);
    }
  })
};
